import React, {useEffect, useState} from "react";
import axios from "axios";

import { shareOnMobile } from "react-mobile-share";
import './welcome.css';

function Welcome({}) {

    const [config, setConfig] = useState();
    const [base64, setBase64] = useState('');
    const searchParams = new URLSearchParams(window.location.search);
    const hash = searchParams.get('h');
    const lang = searchParams.get('l') || "es";
        
    const toDataUrl = (url, callback) => {
        var xhr = new XMLHttpRequest();
        xhr.onload = function() {
            var reader = new FileReader();
            reader.onloadend = function() {
                callback(reader.result);
            }
            reader.readAsDataURL(xhr.response);
        };
        xhr.open('GET', url);
        xhr.responseType = 'blob';
        xhr.send();
    }

    const checkPin = async () => {
        console.log(config);
        const pin = prompt(config.language[lang].pin);

        if (!pin) {
            return checkPin();
        }

        fetch(`${process.env.REACT_APP_HOST_API}/api/photo/${hash}/${pin}`)
            .then(response => response.json())
            .then(response => {
                if (response?.url) {
                    toDataUrl(response.url, result => setBase64(result));
                } else {
                    return checkPin();
                }
            }).catch(err => {
                console.log(err);
                return checkPin();
            });

    }

    useEffect(() => { 
        (async () => {
            await axios.get(`${process.env.REACT_APP_HOST_API}/api/devices/sync/6633632f1fc1891acc88c72d`).then(function (response) {        
                setConfig(response.data);
                
            })        
        })();
    },[]);

    useEffect(() => { 
        if (config) {
            checkPin();
        }
    },[config]);

    return (
        base64 &&
        <div className="welcome">  
            <svg className="logo" width="1087px" height="152px" viewBox="0 0 1087 152" version="1.1" >
                <g id="atleticam">
                    <path d="M1087 0L1087 0L1087 152L0 152L0 0L1087 0Z" id="atleticam" fill={config.backgroundColor} stroke="none" />
                    <path d="M48.1418 92.4658L65.7937 39.1047L82.2421 92.4658L48.1418 92.4658L48.1418 92.4658ZM0 150.715L30.0886 150.715L40.7199 117.721L88.8616 117.721L99.2923 150.715L129.18 150.715L81.4398 1.62961L49.5459 1.62961L0 150.715L0 150.715ZM119.151 27.9029L158.868 27.9029L158.868 150.715L186.95 150.715L186.95 27.9029L227.67 27.9029L227.67 1.62961L119.151 1.62961L119.151 27.9029L119.151 27.9029ZM244.119 121.794C244.119 144.605 258.762 150.715 274.608 150.715L334.986 150.715L334.986 124.441L284.638 124.441C278.821 124.441 272.201 124.645 272.201 113.851L272.201 1.62961L244.119 1.62961L244.119 121.794L244.119 121.794ZM351.635 121.532C351.635 150.14 372.497 153.319 385.535 152.683C385.535 152.683 436.686 150.776 448.119 149.08L448.119 124.711L392.154 124.711C386.337 124.711 379.718 124.923 379.718 113.692L379.718 89.5341L439.093 87.627L439.093 63.0456L379.718 60.9265L379.718 36.769C379.718 31.0475 379.718 24.9021 390.149 24.9021L448.119 24.9021L448.119 0.32076C435.281 -1.58642 383.529 -3.06979 383.529 -3.06979C369.688 -3.28169 351.635 2.22792 351.635 29.1403L351.635 121.532L351.635 121.532ZM459.954 27.9029L499.671 27.9029L499.671 150.715L527.754 150.715L527.754 27.9029L568.474 27.9029L568.474 1.62961L459.954 1.62961L459.954 27.9029L459.954 27.9029ZM584.922 150.715L613.005 150.715L613.005 1.62961L584.922 1.62961L584.922 150.715L584.922 150.715ZM680.403 75.7644C680.403 123.015 693.241 151.529 730.35 151.937C751.412 152.344 768.262 150.511 781.501 146.234L781.501 124.034C781.501 124.034 758.032 125.663 736.97 125.663C713.902 125.663 708.486 109.573 708.486 76.1718C708.486 30.9574 716.309 26.273 736.97 26.273C756.628 26.273 781.3 29.1244 781.501 29.1244L781.501 6.72088C765.654 2.0365 750.81 -0.000167847 730.35 -0.000167847C690.433 -0.000167847 680.403 28.106 680.403 75.7644L680.403 75.7644L680.403 75.7644ZM841.477 92.4658L859.129 39.1047L875.578 92.4658L841.477 92.4658L841.477 92.4658ZM793.335 150.715L823.424 150.715L834.055 117.721L882.197 117.721L892.628 150.715L922.516 150.715L874.775 1.62961L842.881 1.62961L793.335 150.715L793.335 150.715ZM933.749 150.715L961.43 150.715L970.056 51.121L994.729 150.715L1026.02 150.715L1049.69 51.121L1059.32 150.715L1087 150.715L1073.36 1.62961L1034.45 1.62961L1010.17 103.463L985.702 1.62961L946.587 1.62961L933.749 150.715L933.749 150.715Z" id="Sendero#1" fill={config.secondaryColor} fillRule="evenodd" stroke={config.secondaryColor} strokeWidth={3} />
                </g>
            </svg>  
            <div className="Photo">
                <img width="440px" id="photo" src={base64}></img>
            </div>  
            <div className="buttons">
                <a className="buttonSolid" style={{backgroundColor: config.mainColor}} href={base64} download="atleticam.jpg">{config.language[lang].download}</a>
                {
                    navigator.share &&
                    <div className="buttonOutline"  style={{color: config.mainColor, border: "4px solid " + config.mainColor}} onClick={()=>{
                        shareOnMobile({
                            text: config.language[lang].share_text,
                            title: config.language[lang].share_title,
                            images: [base64],
                        })
                    }}>{config.language[lang].share}</div>
                }
            </div>
        </div>
    );

}  

export default Welcome;